module.exports = "pegasus/assets/theme6/facebook-icon-1.png";